angular.module('services.newman.DecisionsService', [
  'global'
])

/**
 * The DecisionsService service stores methods used to
 * handle data for decisions
 *
 * @class DecisionsService
 * @constructor
 * @module services.newman.DecisionsService
 */

.factory('DecisionsService', [
  'ModelsService',
  function (ModelsService) {
    'use strict';

    var service = {

      decisions: [],

      /**
       * Returns decisions.  If a decisionId is
       * provided will return a single case.  If no
       * decisionId is provided will return all decisions.
       *
       * @param {string} [decisionId] - return only a specific case
       * @param {boolean} [format=false] - flag to format output
       * @return {Object|Array<Object>} All entries
       */
      get: function get(decisionId, format) {
        var ret;

        service.decisions = ModelsService.read('decisions');

        if (decisionId) {
          ret = _.cloneDeep(ModelsService.find('decisions', 'id', decisionId));
        } else {
          ret = service.decisions;
        }

        if (format) {
          ret = {
            label: ret.label,
            content: ret.content
          };
        }

        return ret;
      },

      /**
       * Returns resolved objects from a list of IDs
       *
       * @param {Array<string>} list - Array of decision IDs
       * @return {Array<Object>} Collection of decision objects
       */
      getFromList: function getFromList(list) {
        var decisions = [];

        _.forEach(list, function (id) {
          var decisionId = id;
          if (_.isObject(decisionId)) {
            decisionId = decisionId.id;
          }
          decisions.push(ModelsService.find('decisions', 'id', decisionId));
        });

        return decisions;
      },

      /**
       * Creates a new decision by merging provided date with
       * template
       *
       * @return {Promise<Object>} new decision
       */
      create: function create() {
        var decision = {
          label: 'decision-' + uuid.v1(),
          content: {
            stem: '',
            maxAttempts: 1,
            choices: [
              {
                id: 'choice-' + uuid.v1(),
                label: 'Button'
              }
            ]
          }
        };

        var endpoint = ModelsService.find('endpoints', 'label', 'decisions');

        return ModelsService.create(endpoint, decision);
      },

      /**
       * Updates existing decision by merging provided date with
       * template
       *
       * @param {string} id - Decision identifier
       * @param {Object} data - Decision data
       * @return {Promise<Object>} updated decision
       */
      update: function update(id, data) {
        var decision = {
          content: data
        };

        var endpoint = ModelsService.find('decisions', 'id', id);

        return ModelsService.update(endpoint, decision);
      }

    };

    return service;
  }
]);
